<!-- View Docs Release Data Modal -->
<div class="modal fade" id="kt_modal_view_docs_release_data" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center bg-light">
        <h2 class="fw-bold mb-0">Document Release Information</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body py-5 px-8">
        <div *ngIf="docsReleaseData; else noData">
          <!-- Receiver Name -->
          <div class="d-flex flex-column mb-5">
            <span class="text-gray-600 fs-7 fw-semibold mb-1">Receiver Name</span>
            <span class="text-gray-800 fs-6">{{ docsReleaseData.receiverName || 'N/A' }}</span>
          </div>

          <!-- Address -->
          <div class="d-flex flex-column mb-5">
            <span class="text-gray-600 fs-7 fw-semibold mb-1">Address</span>
            <span class="text-gray-800 fs-6" style="white-space: pre-wrap;">{{ docsReleaseData.address || 'N/A' }}</span>
          </div>

          <!-- Post/Zip Code and City -->
          <div class="row mb-5">
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <span class="text-gray-600 fs-7 fw-semibold mb-1">Post/Zip Code</span>
                <span class="text-gray-800 fs-6">{{ docsReleaseData.postZipCode || 'N/A' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <span class="text-gray-600 fs-7 fw-semibold mb-1">City</span>
                <span class="text-gray-800 fs-6">{{ docsReleaseData.city || 'N/A' }}</span>
              </div>
            </div>
          </div>

          <!-- Country -->
          <div class="d-flex flex-column mb-5">
            <span class="text-gray-600 fs-7 fw-semibold mb-1">Country</span>
            <span class="text-gray-800 fs-6">{{ getCountryName(docsReleaseData.country) }}</span>
          </div>

          <!-- Separator -->
          <div class="separator separator-dashed my-6"></div>

          <!-- Contact Person -->
          <div class="d-flex flex-column mb-5">
            <span class="text-gray-600 fs-7 fw-semibold mb-1">Contact Person</span>
            <span class="text-gray-800 fs-6">{{ docsReleaseData.contactPerson || 'N/A' }}</span>
          </div>

          <!-- Phone and Email -->
          <div class="row mb-5">
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <span class="text-gray-600 fs-7 fw-semibold mb-1">Phone No.</span>
                <span class="text-gray-800 fs-6">{{ docsReleaseData.phoneNo || 'N/A' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <span class="text-gray-600 fs-7 fw-semibold mb-1">Email</span>
                <span class="text-gray-800 fs-6">{{ docsReleaseData.email || 'N/A' }}</span>
              </div>
            </div>
          </div>

          <!-- Remarks -->
          <div class="d-flex flex-column mb-5" *ngIf="docsReleaseData.remarks">
            <div class="separator separator-dashed my-6"></div>
            <span class="text-gray-600 fs-7 fw-semibold mb-1">Remarks</span>
            <span class="text-gray-800 fs-6" style="white-space: pre-wrap;">{{ docsReleaseData.remarks }}</span>
          </div>
        </div>

        <ng-template #noData>
          <div class="text-center py-10">
            <i class="ki-duotone ki-information-5 fs-5x text-gray-400 mb-5">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            <p class="text-gray-600 fs-5 fw-semibold">No document release data available</p>
          </div>
        </ng-template>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
